import $ from "dabbyjs/src/core/dabby/dabby.js";
import qrcode from "./qrcode.js";
import code from "./code.js";
import disable from "./disable.js";

export default () => {
	qrcode($('canvas[data-qrcode]'));
	code($(".mfa__code-input"), $(".mfa__code-submit"));
	disable($(".mfa__disable"));
};